module.exports = __webpack_public_path__ + "static/media/camera-off.da0c5e68.svg";